import { render } from "./ProductEnrichmentDialog.vue?vue&type=template&id=575dc16c&scoped=true"
import script from "./ProductEnrichmentDialog.vue?vue&type=script&lang=js"
export * from "./ProductEnrichmentDialog.vue?vue&type=script&lang=js"

import "./ProductEnrichmentDialog.vue?vue&type=style&index=0&id=575dc16c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575dc16c"]])

export default __exports__